import { FC, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import avatar from '../../assets/media/avatars/blank.png'
import { useAuth } from '../../hooks/auth'
import { useToast } from '../../hooks/toast'

const HeaderUserMenu: FC = () => {
  const { signOut, user } = useAuth()
  const history = useHistory()
  const { addToast } = useToast()
  const handleLogout = useCallback(() => {
    signOut()
    history.push('/')
    addToast({
      type: 'info',
      title: 'Logout realizado com sucesso!'
    })
  }, [signOut, history, addToast])

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <img alt="avatar" src={avatar} />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {user?.name}
            </div>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>
      <div className="menu-item px-5">
        <a onClick={handleLogout} className="menu-link px-5">
          Logout
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
